import { createContext, useContext, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBlog } from "../../api/blogs";
import { getLeads } from "../../api/leads";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

const initialValues = {
  Banner: { heading: "", subheading: "", cta: "", ctaRedirectLink: "" },
};

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const getLeadsQuery = useQuery({
    queryKey: [{ page, type: "subscribe" }],
    queryFn: getLeads,
    keepPreviousData: true,
  });

  const deleteBlogQuery = useMutation({ mutationFn: deleteBlog });

  const handleWorkDelete = (item) => {
    deleteBlogQuery.mutate(item._id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["blogs"]);
        toaster.success(Const.MESSAGES.SUCCESS, "Blog is deleted successfully.");
      },
    });
  };

  const handleAddBlogClick = () => {
    navigate("/add-blog");
  };

  const handleEditClick = (item) => {
    navigate(`/add-blog?id=${item.slug_url}`);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <PageContext.Provider value={{ initialValues, getLeadsQuery, handleWorkDelete, handleAddBlogClick, handleEditClick, handlePageChange, currentPage: page }}>
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
